import React, { useState, useEffect } from "react";

const CustomTitle = ({ text }) => {
  const [fontSize, setFontSize] = useState(
    window.innerWidth <= 768 ? "0.6em" : "0.7em"
  );

  useEffect(() => {
    const handleResize = () => {
      setFontSize(window.innerWidth <= 768 ? "0.6em" : "0.7em");
    };

    window.addEventListener("resize", handleResize);

    // Clean up event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        whiteSpace: "normal",
        fontSize: fontSize,
      }}
    >
      {text}
    </div>
  );
};

export default CustomTitle;
